import { Slider } from "../../components/slider";
import { UserPublicModel } from "./model";
import { UserPublicView } from "./view";

export class UserPublicController {
  static instance;
  constructor() {
    if (UserPublicController.instance) {
      throw new Error("Solo puede haber una instancia de usuario público.");
    }
    this.model = new UserPublicModel();
    this.view = new UserPublicView();
  }

  static getInstance() {
    if (!UserPublicController.instance) {
      UserPublicController.instance = new UserPublicController();
    }
    return UserPublicController.instance;
  }

  async show(_permalinkUser) {
    let userIdcod = await this.model.getUserIdcodFromPermalink(_permalinkUser);
    let user = await this.model.getUserInfo(userIdcod);
    content.innerHTML = this.view.renderMain(user);

    let data = [];
    try {
      data = await this.model.getItems(userIdcod);
    } catch (error) {
      data = [];
    }

    for (let i = 0; i < data.length; i++) {
      data[i].user = user;
    }

    let itemsContainer = document.getElementById('user-content');
    if (itemsContainer) {
      if (data.length > 0) {
        itemsContainer.innerHTML = app.itemsController.view.renderCollection(data);
        setTimeout(() => {
          for (let i = 0; i < data.length; i++) {
            new Slider('slider-' + data[i].idcod, data[i].imagenes, true, true, data[i].titulo);
          }
        }, 200);
      } else {
        let userSession = await APICRUD.Auth.InfoSession();
        let vacio = [];
        let html = `<div style="grid-column: span 4;"><h2>Aún no hay publicaciones en este perfil.</h2>`;
        if (userSession !== vacio && userSession.permalink == user.permalink) {
          html += `
            <h1>¿Qué estás esperando?</h1>
            <h3>Comparte a la comunidad el agro tus productos, máquinas, inmuebles y servicios. </h3> 
            <button class="btn-1" onclick="app.userPrivateController.publish()">Comenzar a publicar ahora</button>
          `;
        }
        html += `</div>`;
        itemsContainer.innerHTML = html;
      }
    }
  }
}
